<template>
  <span>{{ data == null ? pk : data.name }}</span>
</template>

<script>
import * as psndoc from '@/api/base/psndoc'

export default {
  name: 'EspPsndocView',
  data() {
    return {
      data: {}
    }
  },
  props: {
    pk: {
      type: String,
      default: ''
    }
  },
  watch: {
    pk: {
      handler: function (newVal, oldVal) {
        this.data = {};
        if (newVal) {
          psndoc.get(newVal).then(res => {
            this.data = res.data;
          }).catch(error => {
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/psndoc/EspPsndocView.vue